// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___35U7E","title":"style__title___1IvOP","textInput":"style__textInput___D8DZJ","inputErrorContainer":"style__inputErrorContainer___3FKEN","inputError":"style__inputError___2LBP7","inputErrorText":"style__inputErrorText___rqgF6","exampleImg":"style__exampleImg___2y2RE","controlsContainer":"style__controlsContainer___RGkoo","backBtn":"style__backBtn___Si_oY"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/components/enter-code/style.css
// module id = 1097
// module chunks = 0